import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { StyledUserNotPermissionContainer } from './userNotPermissionStyles';
import Strings from '../../i18n';
import { setCredentials } from '../../store/slices/login/login';

export const UserNotPermission = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();

  const logoutAndRedirect = () => {
    dispatch(
      setCredentials({
        user: null,
        email: '',
        token: '',
        picture: '',
        roleInfo: null,
        userInfo: null,
        refreshToken: '',
        authWithApi: false,
        userId: 0
      })
    );
    logout({
      logoutParams: { returnTo: `${window.location.origin}/callback` }
    });
  };
  return (
    <StyledUserNotPermissionContainer className="row">
      <div className="col-11 col-md-10 text-center container-text">
        <h1>{Strings.navBar.profileIcon.textNoPermission}</h1>
        <button
          className="btn btn-primary"
          onClick={logoutAndRedirect}
          type="button"
        >
          <i className="pi pi-sign-in mr-2" />
          {Strings.login.backToLogin}
        </button>
      </div>
    </StyledUserNotPermissionContainer>
  );
};
